import { render, staticRenderFns } from "./LeftBlock.vue?vue&type=template&id=52f9519a&scoped=true&"
import script from "./LeftBlock.vue?vue&type=script&lang=ts&"
export * from "./LeftBlock.vue?vue&type=script&lang=ts&"
import style0 from "./LeftBlock.vue?vue&type=style&index=0&id=52f9519a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f9519a",
  null
  
)

export default component.exports